import React from "react";
import { PlayerService } from "../services/PlayerService";
import "./Landing.scss";
import { PlayerSelect } from "./player-choice/Player-Select";
import { GameState } from "../App";
import { PlayerReroll } from "./player-choice/Player-Reroll";

export interface Props {
  playerService: PlayerService;
  gameState: GameState;
  setGameState: (gameState: GameState) => void;
}

export const Landing: React.FC<Props> = ({
  playerService,
  gameState,
  setGameState,
}) => {
  return (
    <div className="landing">
      {gameState === "new" && (
        <PlayerSelect
          playerService={playerService}
          setGameState={setGameState}
        />
      )}
      {gameState === "reset" && (
        <PlayerReroll
          playerService={playerService}
          setGameState={setGameState}
        />
      )}
      {gameState === "victory" && (
        <div className="victory">
          You did it! Speak to the host to receive... someone's... prize!
        </div>
      )}
    </div>
  );
};
